import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, md: 5 },
        backgroundColor: '#f5f5f7',
        borderTop: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: '0.85rem', md: '0.9rem' },
              color: 'rgba(29,29,31,0.5)',
              letterSpacing: '0.005em',
            }}
          >
            © {currentYear} NasRadius. All rights reserved.
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: '0.85rem', md: '0.9rem' },
              color: 'rgba(29,29,31,0.5)',
              letterSpacing: '0.005em',
            }}
          >
            Contact us:{' '}
            <Box
              component="a"
              href="tel:+254724440202"
              sx={{
                color: '#0b74c1',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: '#19b594',
                },
              }}
            >
              0724440202
            </Box>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
